import { render, staticRenderFns } from "./ConciergeRequests.vue?vue&type=template&id=cfd728b8&scoped=true"
import script from "./ConciergeRequests.ts?vue&type=script&lang=ts&external"
export * from "./ConciergeRequests.ts?vue&type=script&lang=ts&external"
import style0 from "./ConciergeRequests.vue?vue&type=style&index=0&id=cfd728b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd728b8",
  null
  
)

export default component.exports